import React, { useEffect, useState, useRef, useCallback } from "react";
import Swal from "sweetalert2";
import { IoMdClose } from "react-icons/io";
import { IoCloseSharp, IoSearchSharp } from "react-icons/io5";
import { SlOptionsVertical } from "react-icons/sl";
// import CadastroContribuinteModal from "../../components/CadastroContribuinteModal/cadastroContribuinteModal";
import InputComponent from "../../components/Input/input";
import { GetContribuinteDto } from "../../shared/dtos/Contribuinte.dto";
import contribuinteService from "../../services/ContribuinteService";
import loadSCGif from "../../assets/load_SC.gif";
import "../../shared/styles/global.scss";
import Button from "../../components/Button/button";
import {
  ContainerButtons,
  ContainerFilter,
  ContainerSearch,
  LoadingContainer,
  MainContainer,
  EmptySearchContainer,
  EmptySearchMessage,
} from "./style";
import { Colors } from "../../shared/colors/colors";
import {
  ButtonAction,
  MenuTable,
  MenuTableDivider,
  MenuTableItem,
  Table,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
  TableContainer,
} from "../../components/Table/styles";
import { Badge, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Label } from "../../components/Label/styles";
import Pagination from "../../components/Pagination/pagination";
import {
  BlueTitle,
  GrayTitle,
  LoadingGif,
  LoadingOverlay,
  StyledHR,
} from "../../shared/styles/global.styles";
// import CadastroParcelasVariosContribuintes from "../../components/CadastroParcelasVariosContribuintes/CadastroParcelasVariosContribuintes";
import { useAuth } from "../../AuthContext/AuthContext";
import { ModulosEnum } from "../../shared/enum/modulos.enum";
import { PermissoesEnum } from "../../shared/enum/permicao.enum";
import {
  IDadosFinanceiros,
  ResponseSearchFastContribuinte,
  ResponseSearchFastDependente,
} from "../../shared/dtos/ReponseFastSearch.dto";
import FichaFinanceiraService from "../../services/FichaFinanceiraService";
import { formatarData, formatDateToBR } from "../../utils/dateUtils/dateUtils";
import { formatCurrency } from "../../utils/formatCurrency/formatCurrency";
import {
  StatusImpressaoEnum,
  StatusParcelaEnum,
  StatusRemessaEnum,
} from "../../shared/enum/fichaFinanceira.enum";
import { ReciboService } from "../../services/ReciboService";
import ReciboDoacaoPDF from "../../components/Recibo_Doação/recibo_doacao";
import { pdf } from "@react-pdf/renderer";
import {
  GetFinancialRecordDto,
  UpdateStatusImpressaoDto,
} from "../../shared/dtos/FichaFinanceira.dto";
import DetailsModal from "../../components/DetalheModal/detalhe_modal";
import QrCodeModal from "../../components/QRCodeModal/qrCode_modal";
import ManualClearanceModal from "../../components/ManualClearanceModal/manualClearanceModal";
import CancelInstallmentsModal from "../../components/CancelInstallmentsModal/cancelInstallments";
import dadosFinanceirosService from "../../services/DadosFinanceirosService";
// import CadastroParcela from "../../components/ModalCadastroParcela/ModalCadastroParcela";
import { GetDadosFinanceirosDto } from "../../shared/dtos/DadosFinanceiros.dto";
import ModalSelectData from "./SelectDataModal/modalSelectData";
import { applyMask } from "../../utils/maskid/maskidValue";
import { MaskEnum } from "../../utils/maskid/enum/mask.enum";
import moment from "moment";

const ConsultaRapida = () => {
  const { checkPermission } = useAuth();
  const menuRefsMap = useRef<Map<number, HTMLDivElement | null>>(new Map());
  const editOnly = checkPermission(
    ModulosEnum.CONSULTA_RAPIDA,
    PermissoesEnum.ESCRITA
  );
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalParcelas, setTotalParcelas] = useState<number>(0);
  const totalPages = Math.ceil(totalParcelas / itemsPerPage);

  const [searchContribuinte, setSearchContribuinte] = useState<string>("");
  const [searchFichaFinanceira, setSearchFichaFinanceira] =
    useState<string>("");
  const [isSearchContribuinte, setIsSearchContribuinte] =
    useState<boolean>(false);
  const [isSearchFichaFinanceira, setIsSearchFichaFinanceira] =
    useState<boolean>(false);
  const [contribuinteData, setContribuinteData] =
    useState<ResponseSearchFastContribuinte>();
  const [dependenteData, setDependenteData] =
    useState<ResponseSearchFastDependente>();

  const [contribuinteDataSelect, setContribuinteDataSelect] =
    useState<ResponseSearchFastContribuinte[]>();
  const [dependenteDataSelect, setDependenteDataSelect] =
    useState<ResponseSearchFastDependente[]>();

  const [fichaFinanceiraData, setfichaFinanceiraData] =
    useState<GetFinancialRecordDto[]>();

  const [selectedFichas, setSelectedFichas] = useState<GetFinancialRecordDto[]>(
    []
  );
  const [selectedFicha, setSelectedFicha] =
    useState<GetFinancialRecordDto | null>(null);

  const [showManualClearanceModal, setShowManualClearanceModal] =
    useState<boolean>(false);
  const [showCancelInstallmentsModal, setShowCancelInstallmentsModal] =
    useState<boolean>(false);
  const [showModalQRCode, setShowModalQRCode] = useState<boolean>(false);
  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);
  // const [showCadastroParcela, setShowCadastroParcela] =
  //   useState<boolean>(false);
  const [showSelectDataModal, setShowSelectDataModal] =
    useState<boolean>(false);

  const [checkBoxCompleta, setCheckBoxCompleta] = useState<boolean>(false);
  const [checkBoxPagas, setCheckBoxPagas] = useState<boolean>(false);

  const [isRequest, setIsRequest] = useState<boolean>(false);
  const [isRequestFichaFinanceira, setIsRequestFichaFinanceira] =
    useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<number | null>(null);

  const todasParcelasPagas =
    selectedFichas.length > 0 &&
    selectedFichas.every(
      (parcela) => parcela.statusParcela === StatusParcelaEnum.PAGA
    );

  const getContribuinteBySearchContribuinte = async (search: string) => {
    if (!searchContribuinte || searchContribuinte === "") {
      Swal.fire({
        icon: "error",
        title: "Pesquisa vazio",
        text: "Insira o nome ou cpf para consultar",
        confirmButtonText: "OK",
        confirmButtonColor: Colors.primary,
        allowOutsideClick: false,
        customClass: {
          confirmButton: "btn btn-primary",
          popup: "animated fadeInDown",
        },
      });
      setLoading(false);
      setIsRequest(false);
      return;
    }
    clearContribuinteDependenteData();
    setLoading(true);
    setIsRequest(true);
    setIsSearchContribuinte(true);
    setSearchFichaFinanceira("");
    setIsSearchFichaFinanceira(false);

    Swal.fire({
      title: "Procurando informações",
      text: "Aguarde",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    await contribuinteService
      .getContribuinteSearchFast(search)
      .then((response) => {
        if (response) {
          if (
            response.contribuinteData.length === 0 &&
            response.dependenteData.length === 0
          ) {
            Swal.fire({
              icon: "info",
              title: "Nenhum resultado encontrado",
              text: "Nenhum resultado encontrado para a pesquisa.",
              confirmButtonText: "OK",
              confirmButtonColor: Colors.primary,
              allowOutsideClick: false,
              customClass: {
                confirmButton: "btn btn-primary",
                popup: "animated fadeInDown",
              },
            });
            return;
          }
          if (
            response.contribuinteData &&
            response.dependenteData &&
            response.contribuinteData.length >= 1 &&
            response.dependenteData.length >= 1
          ) {
            setContribuinteDataSelect(response.contribuinteData);
            setDependenteDataSelect(response.dependenteData);
            setShowSelectDataModal(true);
          } else {
            if (
              response.dependenteData &&
              response.dependenteData.length >= 1
            ) {
              if (response.dependenteData.length > 1) {
                setDependenteDataSelect(response.dependenteData);
                setShowSelectDataModal(true);
              } else {
                setDependenteData(response.dependenteData[0]);
                setContribuinteData(response.dependenteData[0].contribuinte);
                // Swal.fire({
                //   icon: "success",
                //   title: "Sucesso",
                //   text: "Dados carregados com sucesso!",
                //   showConfirmButton: true,
                //   confirmButtonText: "OK",
                // });
              }
            } else {
              if (
                response.contribuinteData &&
                response.contribuinteData.length >= 1
              ) {
                if (response.contribuinteData.length > 1) {
                  setContribuinteDataSelect(response.contribuinteData);
                  setShowSelectDataModal(true);
                } else {
                  setContribuinteData(response.contribuinteData[0]);
                  Swal.close();
                  // Swal.fire({
                  //   icon: "success",
                  //   title: "Sucesso",
                  //   text: "Dados carregados com sucesso!",
                  //   showConfirmButton: true,
                  //   confirmButtonText: "OK",
                  // });
                }
              }
            }
          }
        }
        Swal.close();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: error.message || "Ocorreu um erro ao buscar as informações",
          allowOutsideClick: false,
        });
      })
      .finally(() => {
        setLoading(false);
        setIsRequest(false);
      });
  };

  const getContribuinteBySearchFichaFinanceira = async (search: string) => {
    if (!searchFichaFinanceira || searchFichaFinanceira === "") {
      Swal.fire({
        icon: "error",
        title: "Pesquisa vazio",
        text: "Insira os dados da ficha financeira para consultar",
        confirmButtonText: "OK",
        confirmButtonColor: Colors.primary,
        allowOutsideClick: false,
        customClass: {
          confirmButton: "btn btn-primary",
          popup: "animated fadeInDown",
        },
      });
      setLoading(false);
      setIsRequest(false);
      return;
    }
    clearContribuinteDependenteData();
    setLoading(true);
    setIsRequest(true);
    setIsSearchFichaFinanceira(true);
    setSearchContribuinte("");
    setIsSearchContribuinte(false);
    Swal.fire({
      title: "Procurando informações",
      text: "Aguarde",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    await FichaFinanceiraService.getContribuinteSearchFast(search)
      .then((response) => {
        if (response) {
          if (
            response.fichaFinanceiraNossoNumero === null &&
            response.fichaFinanceiraNumeroDocumento === null &&
            response.fichaFinanceiraLinhaDigitavel === null &&
            response.fichaFinanceiraCodBarras === null
          ) {
            Swal.fire({
              icon: "info",
              title: "Nenhum resultado encontrado",
              text: "Nenhum resultado encontrado para a pesquisa.",
              confirmButtonText: "OK",
              confirmButtonColor: Colors.primary,
              allowOutsideClick: false,
              customClass: {
                confirmButton: "btn btn-primary",
                popup: "animated fadeInDown",
              },
            });
            return;
          }
          const opcoesPreenchidas = [
            response.fichaFinanceiraNossoNumero,
            response.fichaFinanceiraNumeroDocumento,
            response.fichaFinanceiraLinhaDigitavel,
            response.fichaFinanceiraCodBarras,
          ].filter(Boolean).length;

          if (opcoesPreenchidas >= 2) {
            const contribuintes = [
              response.fichaFinanceiraNossoNumero?.contribuinte,
              response.fichaFinanceiraNumeroDocumento?.contribuinte,
              response.fichaFinanceiraLinhaDigitavel?.contribuinte,
              response.fichaFinanceiraCodBarras?.contribuinte,
            ].filter(Boolean);

            setContribuinteDataSelect(contribuintes);
            setShowSelectDataModal(true);
          } else {
            if (response.fichaFinanceiraNossoNumero) {
              setContribuinteData(
                response.fichaFinanceiraNossoNumero.contribuinte
              );
            } else if (response.fichaFinanceiraNumeroDocumento) {
              setContribuinteData(
                response.fichaFinanceiraNumeroDocumento.contribuinte
              );
            } else if (response.fichaFinanceiraLinhaDigitavel) {
              setContribuinteData(
                response.fichaFinanceiraLinhaDigitavel.contribuinte
              );
            } else if (response.fichaFinanceiraCodBarras) {
              setContribuinteData(
                response.fichaFinanceiraCodBarras.contribuinte
              );
            }
          }
          Swal.close();
          // Swal.fire({
          //   icon: "success",
          //   title: "Sucesso",
          //   text: "Dados carregados com sucesso!",
          //   showConfirmButton: true,
          //   confirmButtonText: "OK",
          // });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: error.message || "Ocorreu um erro ao buscar as informações",
          allowOutsideClick: false,
        });
      })
      .finally(() => {
        setLoading(false);
        setIsRequest(false);
      });
  };

  const clearContribuinteDependenteData = () => {
    setContribuinteData(undefined);
    setDependenteData(undefined);
    setContribuinteDataSelect([]);
    setDependenteDataSelect([]);
    setSelectedFichas([]);
    setSelectedFicha(null);
    setShowSelectDataModal(false);
    setShowManualClearanceModal(false);
    setShowCancelInstallmentsModal(false);
    setShowModalQRCode(false);
    setShowDetailsModal(false);
    setIsOpen(null);
    setCurrentPage(1);
    setIsRequestFichaFinanceira(false);
    setIsRequest(false);
    setLoading(false);
  };

  const clearSearchInput = (setSearch: any, setIsSearch: any) => {
    setSearch("");
    setIsSearch(false);
    clearContribuinteDependenteData();
  };

  const getFichasFinanceiras = async (
    id: number,
    page: number,
    take: number,
    completa: boolean,
    pagas: boolean
  ) => {
    setIsRequestFichaFinanceira(true);
    await FichaFinanceiraService.getFichasFinanceirasSearchFast(
      id,
      page,
      take,
      completa,
      pagas
    )
      .then((response) => {
        if (response) {
          setfichaFinanceiraData(response.data);
          setTotalParcelas(response.total);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Erro",
          allowOutsideClick: false,
          text:
            error.message || "Ocorreu um erro ao buscar as fichas financeiras",
        });
      })
      .finally(() => {
        setIsRequestFichaFinanceira(false);
      });
  };

  const gerarReciboParcelaPDF = async (parcelas: GetFinancialRecordDto[]) => {
    try {
      // Exibe loading enquanto processa
      Swal.fire({
        title: "Carregando",
        text: "Gerando recibo...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Primeiro, chama o serviço para criar o recibo e obter o número sequencial
      const fichaFinanceiraIds = parcelas.map((parcela) => parcela.id);

      // Importa o ReciboService no topo do arquivo se ainda não estiver importado
      const reciboResponse = await ReciboService.create({
        fichaFinanceiraIds: fichaFinanceiraIds,
        contribuinteId: parcelas[0].idContribuinte,
      });

      const usuario: string =
        JSON.parse(sessionStorage.getItem("user") || "{}").name || "";
      const dateRange = {
        inicio:
          reciboResponse.length > 0
            ? formatDateToBR(parcelas[0].dataVencimento)
            : "",
        fim:
          reciboResponse.length > 0
            ? formatDateToBR(parcelas[reciboResponse.length - 1].dataVencimento)
            : "",
      };

      const responsavel = parcelas[0]?.contribuinte?.nome || "";
      const cpf = parcelas[0]?.contribuinte?.cpfCin || "";

      // Fecha o loading antes de gerar o PDF
      Swal.close();
      const blob = await pdf(
        <ReciboDoacaoPDF
          dateRange={dateRange}
          responsavel={responsavel}
          recibos={reciboResponse} // Passa o array de recibos
          cpf={cpf}
          usuario={usuario}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      window.open(url);
      setSelectedFichas([]);
    } catch (error) {
      console.error("Erro ao gerar recibo:", error);
      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao gerar o recibo. Tente novamente.",
        icon: "error",
        allowOutsideClick: false,
      });
    }
  };

  const createBillOfPay = async (
    fichasFinanceiras: GetFinancialRecordDto[]
  ) => {
    const data = {
      idFichaFinanceira: fichasFinanceiras.map((fichas) => fichas.id),
    };

    try {
      Swal.fire({
        title: "Carregando",
        text: "Carregando boletos...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await FichaFinanceiraService.createBillOfPay(data);
      if (response.success) {
        // Abrir o PDF
        window.open(
          `${process.env.REACT_APP_API_URL}pdfs/${response.data.nameFile}`,
          "_blank"
        );

        // Aguardar 1 segundo antes de deletar (tempo para o navegador abrir o PDF)
        setTimeout(async () => {
          const deleteResponse = await FichaFinanceiraService.deleteFileInPdfs(
            response.data.nameFile
          );

          if (deleteResponse.success) {
            const firstResult = await Swal.fire({
              title: "Sucesso!",
              text: "Os boletos foram carregados com sucesso!",
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });

            if (firstResult.isConfirmed) {
              if (
                fichasFinanceiras.some(
                  (installment) =>
                    installment.statusImpressao ===
                    StatusImpressaoEnum.A_IMPRIMIR
                )
              ) {
                const result = await Swal.fire({
                  title: "Sucesso!",
                  text: `Deseja trocar o status da impressão para ${StatusImpressaoEnum.IMPRESSO}?`,
                  icon: "info",
                  showCancelButton: true,
                  confirmButtonText: "Sim",
                  cancelButtonText: "Não",
                  allowOutsideClick: false,
                });

                if (result.isConfirmed) {
                  const data: UpdateStatusImpressaoDto = {
                    ids: fichasFinanceiras.map((ficha) => ficha.id),
                    status: StatusImpressaoEnum.IMPRESSO,
                  };
                  await FichaFinanceiraService.updateStatusImpressaoMany(
                    data
                  ).then(async (response) => {
                    if (response.success) {
                      Swal.fire({
                        title: "Sucesso!",
                        text: "Status dos boletos atualizados com sucesso!",
                        icon: "success",
                        confirmButtonText: "OK",
                        allowOutsideClick: false,
                      });
                      await getFichasFinanceiras(
                        contribuinteData?.id!,
                        currentPage,
                        itemsPerPage,
                        checkBoxCompleta,
                        checkBoxPagas
                      );
                    }
                  });
                }
              }
            }
          }
        }, 2000); // tempo em milissegundos
      } else {
        Swal.fire({
          title: "Erro",
          text: "Ocorreu um erro ao gerar o boleto. Por favor, tente novamente.",
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao gerar o PDF. Tente novamente.",
        icon: "error",
        allowOutsideClick: false,
      });
    }
    setSelectedFichas([]);
  };

  const handleUpdate = async (
    id: number,
    statusImpressao: StatusImpressaoEnum
  ) => {
    try {
      const result = await Swal.fire({
        title: "Trocar status da impressão",
        text: "Selecione uma opção",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
        input: "select",
        inputOptions: {
          [StatusImpressaoEnum.A_IMPRIMIR]: "A Imprimir",
          [StatusImpressaoEnum.IMPRESSO]: "Impresso",
          [StatusImpressaoEnum.NAO_IMPRIMIR]: "Não Imprimir",
          [StatusImpressaoEnum.PENDENTE]: "Pendente",
        },
        inputValue: statusImpressao, // Define o status selecionado como padrão
        inputValidator: (value) => {
          if (value === statusImpressao) {
            return "Selecione uma opção diferente da atual";
          }
        },
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Carregando",
          text: "Atualizando status da impressão...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        await FichaFinanceiraService.update(id, {
          statusImpressao: result.value,
        });

        Swal.close();
      }
    } catch (error) {
      console.error("Erro ao trocar status da impressão:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Erro ao trocar status da impressão",
        allowOutsideClick: false,
      });
    }
  };

  const handleUpdateRemessa = async (
    id: number,
    statusRemessaAtual: string
  ) => {
    try {
      const result = await Swal.fire({
        title: "Trocar status da remessa",
        text: "Selecione uma opção",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
        input: "select",
        inputOptions: {
          [StatusRemessaEnum.ENVIAR]: "Enviar",
          [StatusRemessaEnum.NAO_ENVIAR]: "Não enviar",
          [StatusRemessaEnum.ENVIADA]: "Enviada",
        },
        inputValue: statusRemessaAtual, // Define o status selecionado como padrão
        inputValidator: (value) => {
          if (value === statusRemessaAtual) {
            return "Selecione uma opção diferente da atual";
          }
        },
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Carregando",
          text: "Atualizando status remessa...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        await FichaFinanceiraService.update(id, {
          statusRemessa: result.value,
        });

        Swal.close();
      }
    } catch (error) {
      console.error("Erro ao trocar status da remessa:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Erro ao trocar status da remessa",
        allowOutsideClick: false,
      });
    }
  };

  const toggleDropdown = (id: number) => {
    setIsOpen(id === isOpen ? null : id);
  };

  // const adjustSetDadosFinanceiros = (dadosFinanceiros: IDadosFinanceiros) => {
  //   const data: GetDadosFinanceirosDto = {
  //     id: dadosFinanceiros.id,
  //     dataInclusao: dadosFinanceiros.dataInclusao,
  //     frequenciaParcela: dadosFinanceiros.frequenciaParcela,
  //     localPagamento: {
  //       id: dadosFinanceiros.localPagamento.id!,
  //       descricao: dadosFinanceiros.localPagamento.descricao,
  //       layoutRemessa: dadosFinanceiros.localPagamento.layoutRemessa
  //         ? dadosFinanceiros.localPagamento.layoutRemessa
  //         : undefined,
  //     },
  //     imprimir: dadosFinanceiros.imprimir ? dadosFinanceiros.imprimir : true,
  //     dataExclusao: dadosFinanceiros.dataExclusao,
  //     lotacao:
  //       dadosFinanceiros.lotacao && dadosFinanceiros.lotacao.id
  //         ? {
  //             id: dadosFinanceiros.lotacao.id,
  //             descricao: dadosFinanceiros.lotacao.descricao,
  //           }
  //         : undefined,
  //     valorDependente: dadosFinanceiros.valorDependente,
  //     valorTitular: dadosFinanceiros.valorTitular,
  //   };
  //   return data;
  // };

  const handleSelectAll = (fichasFinanceiras: GetFinancialRecordDto[]) => {
    if (selectedFichas.length === fichaFinanceiraData?.length) {
      setSelectedFichas([]);
    } else {
      setSelectedFichas(fichasFinanceiras);
    }
  };

  const handleManualClearance = async () => {
    try {
      // Confirma a reativação
      const result = await Swal.fire({
        title: "Confirmação",
        text: `Deseja realmente reativar ${selectedFichas.length} parcela${
          selectedFichas.length > 1 ? "s" : ""
        }?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim, reativar",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
      });

      if (result.isConfirmed) {
        // Mostra loading
        Swal.fire({
          title: "Carregando",
          text: "Reativando parcelas...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        // Chama o serviço para reativar as parcelas (enviando apenas os IDs)
        await dadosFinanceirosService.reativarParcelas(
          selectedFichas.map((id) => Number(id.id))
        );

        // Atualiza a lista de parcelas

        // Limpa a seleção
        setSelectedFichas([]);

        // Mostra mensagem de sucesso
        Swal.fire({
          title: "Sucesso!",
          text: "Parcelas reativadas com sucesso",
          icon: "success",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error("Erro ao reativar parcelas:", error);
      Swal.fire({
        title: "Erro",
        text: "Não foi possível reativar as parcelas. Tente novamente.",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
    }
  };

  const handlePageChange = (pageNumber: number) => {
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
    }
  };

  const handleCheckBox = (setCheckBox: any, value: boolean) => {
    setCheckBox(value);
    setCurrentPage(1);
  };

  const getBadgeBackground = (
    status: StatusParcelaEnum,
    dataVencimento?: string
  ) => {
    // Se a data de vencimento foi fornecida e a parcela está ativa, verifica se está vencida
    if (dataVencimento && status === StatusParcelaEnum.ATIVA) {
      const hoje = new Date();
      const dataVenc = new Date(dataVencimento);

      // Se a data atual for maior que a data de vencimento, considera como vencida
      if (hoje > dataVenc) {
        return "rgba(220, 53, 69, 0.5)"; // Cor para status VENCIDA
      }
    }

    // Se não estiver vencida ou não tiver data de vencimento, usa o status normal
    switch (status) {
      case StatusParcelaEnum.ATIVA:
        return "rgba(40, 167, 69, 0.5)";
      case StatusParcelaEnum.VENCIDA:
        return "rgba(220, 53, 69, 0.5)";
      case StatusParcelaEnum.PAGA:
        return "rgba(135, 206, 235, 0.5)";
      default:
        return "#1f2937";
    }
  };

  const ReversalManualClearance = async (ficha: GetFinancialRecordDto) => {
    if (!ficha) {
      Swal.fire({
        title: "Erro",
        text: "Selecione pelo menos uma parcela.",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return;
    }

    const { value: formValues } = await Swal.fire({
      title: "Confirmar estorno",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sim, estornar",
      cancelButtonText: "Cancelar",
      allowOutsideClick: false,
      html: `
        <div style="display: flex; flex-direction: column; gap: 10px; text-align: left;">
        <p><strong>Deseja estornar a parcela?</strong></p>
          <p><strong>Titular:</strong> ${ficha.contribuinte?.nome || ""}</p>
          <p><strong>Nosso Número:</strong> ${ficha.nossoNumero}</p>
          <p><strong>Vencimento:</strong> ${formatDateToBR(
            ficha.dataVencimento
          )}</p>
          <p><strong>Valor:</strong> ${formatCurrency(ficha.valorParcela)}</p>
        </div>
      `,
      focusConfirm: false,
      preConfirm: () => {
        return {
          id: ficha.id,
        };
      },
    });

    if (formValues) {
      Swal.fire({
        title: "Carregando",
        text: "Estornando parcela...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      await FichaFinanceiraService.ReversalManualClearance(formValues.id)
        .then(async (response) => {
          Swal.close();
          if (response.success) {
            Swal.fire({
              title: "Sucesso",
              html: `
              <div style="display: flex; flex-direction: column; gap: 10px; text-align: left;">
              <p><strong>${response.message}</strong></p>
                <p><strong>Titular:</strong> ${
                  ficha.contribuinte?.nome || ""
                }</p>
                <p><strong>Nosso Número:</strong> ${ficha.nossoNumero}</p>
                <p><strong>Vencimento:</strong> ${formatDateToBR(
                  ficha.dataVencimento
                )}</p>
                <p><strong>Valor:</strong> ${formatCurrency(
                  ficha.valorParcela
                )}</p>
              </div>
            `,
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
            await getFichasFinanceiras(
              contribuinteData?.id!,
              currentPage,
              itemsPerPage,
              checkBoxCompleta,
              checkBoxPagas
            );
            setSelectedFichas([]);
          } else {
            Swal.fire({
              title: "Erro",
              text: response.message,
              icon: "error",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
          }
        })
        .catch((error) => {
          Swal.close();
          Swal.fire({
            title: "Erro",
            text: error.message,
            icon: "error",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
        });
    }
  };

  useEffect(() => {
    // Função para fechar o menu se o clique for fora dele
    const handleClickOutside = (event: MouseEvent) => {
      // Se não tiver menu aberto, não faz nada
      if (isOpen === null) return;

      // Verifica se o clique foi dentro do menu atual
      const currentMenuRef = menuRefsMap.current.get(isOpen);
      if (currentMenuRef && !currentMenuRef.contains(event.target as Node)) {
        setIsOpen(null);
      }
    };

    // Adiciona o event listener quando o menu estiver aberto
    if (isOpen !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Limpeza do event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    if (contribuinteData && !isRequest) {
      getFichasFinanceiras(
        contribuinteData.id,
        currentPage,
        itemsPerPage,
        checkBoxCompleta,
        checkBoxPagas
      );
    }
  }, [currentPage, contribuinteData]);

  useEffect(() => {
    if (contribuinteData && !isRequest) {
      getFichasFinanceiras(
        contribuinteData.id,
        currentPage,
        itemsPerPage,
        checkBoxCompleta,
        checkBoxPagas
      );
    }
  }, [checkBoxCompleta, checkBoxPagas]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(Math.max(totalPages, 1));
    }
  }, [totalPages]);

  return (
    <div className="custom-container important" style={{ overflowX: "auto" }}>
      <MainContainer>
        <GrayTitle>Consulta rápida</GrayTitle>
        <StyledHR />

        {loading ? (
          <LoadingOverlay>
            <LoadingGif src={loadSCGif} alt="Carregando..." />
          </LoadingOverlay>
        ) : (
          <>
            <ContainerSearch>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  getContribuinteBySearchContribuinte(searchContribuinte); // Quando pressionar Enter, ativa a busca
                }}
              >
                <ContainerFilter>
                  <Label htmlFor="cpf-search" id="form-label">
                    Busque pelo nome ou CPF
                  </Label>
                  <InputComponent
                    type="text"
                    id="search"
                    value={searchContribuinte}
                    onChange={(e) => setSearchContribuinte(e.target.value)}
                    placeholder="Busque pelo nome ou CPF"
                    color="black"
                    width={400}
                    iconRight={
                      isSearchContribuinte ? (
                        <IoCloseSharp size={24} color={Colors.inputIcon} />
                      ) : (
                        <IoSearchSharp size={24} color={Colors.inputIcon} />
                      )
                    }
                    onIconRightClick={() => {
                      isSearchContribuinte
                        ? clearSearchInput(
                            setSearchContribuinte,
                            setIsSearchContribuinte
                          )
                        : getContribuinteBySearchContribuinte(
                            searchContribuinte
                          );
                    }}
                    disabled={isRequest}
                  />
                </ContainerFilter>
              </form>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  getContribuinteBySearchFichaFinanceira(searchFichaFinanceira); // Quando pressionar Enter, ativa a busca
                }}
              >
                <ContainerFilter>
                  <Label htmlFor="cpf-search" id="form-label">
                    Busque pelo cod. de barras, linha digitável ou nosso número
                  </Label>
                  <InputComponent
                    type="text"
                    id="search"
                    value={searchFichaFinanceira}
                    onChange={(e) => setSearchFichaFinanceira(e.target.value)}
                    placeholder="Busque pela linha digitável ou nosso número"
                    color="black"
                    width={480}
                    iconRight={
                      isSearchFichaFinanceira ? (
                        <IoCloseSharp size={24} color={Colors.inputIcon} />
                      ) : (
                        <IoSearchSharp size={24} color={Colors.inputIcon} />
                      )
                    }
                    onIconRightClick={() => {
                      isSearchFichaFinanceira
                        ? clearSearchInput(
                            setSearchFichaFinanceira,
                            setIsSearchFichaFinanceira
                          )
                        : getContribuinteBySearchFichaFinanceira(
                            searchFichaFinanceira
                          );
                    }}
                    disabled={isRequest}
                  />
                </ContainerFilter>
              </form>
            </ContainerSearch>
            <StyledHR />
            {contribuinteData ? (
              <>
                <BlueTitle marginBottom={1}>Resultado da pesquisa:</BlueTitle>
                <TableContainer marginBottom={1}>
                  <Table id="contribuinte-table">
                    <TableHead>
                      <TableRow>
                        <TableHeader>Tipo contribuinte</TableHeader>
                        <TableHeader>Nome</TableHeader>
                        <TableHeader>CPF</TableHeader>
                        <TableHeader>Tipo movimentação</TableHeader>
                        <TableHeader>Data movimentação</TableHeader>
                        <TableHeader>Fim da carência</TableHeader>
                        <TableHeader>Motivo exclusão</TableHeader>
                      </TableRow>
                    </TableHead>
                    <tbody style={{ maxHeight: 10 }}>
                      <TableRow key={`Dados-${contribuinteData.id}`}>
                        <TableData>TITULAR</TableData>
                        <TableData>
                          {contribuinteData.nome.toUpperCase()}
                        </TableData>
                        <TableData>{contribuinteData.cpfCin}</TableData>
                        {contribuinteData.movimentacoes.length === 0 ? (
                          <>
                            <TableData
                              colSpan={4}
                              className="text-center text-muted"
                              style={{
                                color: "rgba(0, 0, 0, 0.5)",
                                background: "rgba(220, 53, 69, 0.5)",
                                fontWeight: "bold",
                              }}
                            >
                              NÃO POSSUI DADOS DE MOVIMENTAÇÃO
                            </TableData>
                          </>
                        ) : (
                          <>
                            <TableData>
                              {contribuinteData.movimentacoes[0].tipo.toUpperCase()}
                            </TableData>
                            <TableData>
                              {moment(
                                contribuinteData.movimentacoes[0]
                                  .data_movimentacao
                              ).format("DD/MM/YYYY")}
                            </TableData>
                            <TableData>
                              {contribuinteData.movimentacoes[0]
                                .data_fim_carencia
                                ? moment(
                                    contribuinteData.movimentacoes[0]
                                      .data_fim_carencia
                                  ).format("DD/MM/YYYY")
                                : "N/A"}
                            </TableData>
                            <TableData>
                              {contribuinteData.movimentacoes[0].tipoExclusao
                                ?.nome || "N/A"}
                            </TableData>
                          </>
                        )}
                      </TableRow>
                      {dependenteData && (
                        <TableRow key={`Dados-${dependenteData.id}`}>
                          <TableData>DEPENDENTE</TableData>
                          <TableData>
                            {dependenteData.nome.toUpperCase()}
                          </TableData>
                          <TableData>{dependenteData.cpfCin}</TableData>
                          {dependenteData.movimentacoes.length === 0 ? (
                            <>
                              <TableData
                                colSpan={4}
                                className="text-center text-muted"
                                style={{
                                  color: "rgba(0, 0, 0, 0.5)",
                                  background: "rgba(220, 53, 69, 0.5)",
                                  fontWeight: "bold",
                                }}
                              >
                                NÃO POSSUI DADOS DE MOVIMENTAÇÃO
                              </TableData>
                            </>
                          ) : (
                            <>
                              <TableData>
                                {dependenteData.movimentacoes[0].tipo.toUpperCase()}
                              </TableData>
                              <TableData>
                                {moment(
                                  dependenteData.movimentacoes[0]
                                    .data_movimentacao
                                ).format("DD/MM/YYYY")}
                              </TableData>
                              <TableData>
                                {dependenteData.movimentacoes[0]
                                  .data_fim_carencia
                                  ? moment(
                                      dependenteData.movimentacoes[0]
                                        .data_fim_carencia
                                    ).format("DD/MM/YYYY")
                                  : "N/A"}
                              </TableData>
                              <TableData>
                                {dependenteData.movimentacoes[0].tipoExclusao
                                  ?.nome || "N/A"}
                              </TableData>
                            </>
                          )}
                        </TableRow>
                      )}
                    </tbody>
                  </Table>
                </TableContainer>
                <StyledHR />
                <BlueTitle marginBottom={1}>Dados de localização</BlueTitle>

                <Label>
                  {contribuinteData.endereco.toUpperCase()} - N°{" "}
                  {contribuinteData.numeroResidencial} -{" "}
                  {contribuinteData.complementoEndereco &&
                    `${contribuinteData.complementoEndereco.toUpperCase()} - `}
                  {contribuinteData.bairro.toUpperCase()}
                </Label>

                <Label marginTop="-0.8%">
                  {applyMask(contribuinteData.cep, MaskEnum.CEP)} -{" "}
                  {contribuinteData.cidade.toUpperCase()} -{" "}
                  {contribuinteData.uf.toUpperCase()}
                </Label>

                <StyledHR />
                <BlueTitle marginBottom={1}>Dados de contato</BlueTitle>
                <TableContainer marginBottom={1} style={{ marginTop: "-1%" }}>
                  <Table id="lotacao-table">
                    <TableHead></TableHead>
                    <Label>Contatos do titular</Label>
                    <tbody>
                      <TableRow key={`Contato-${contribuinteData.id}`}>
                        <TableData>
                          <strong>Celular: </strong>
                          {contribuinteData.celular || "N/A"}
                        </TableData>

                        <TableData>
                          <strong>Residencial: </strong>
                          {contribuinteData.telefoneResidencial || "N/A"}
                        </TableData>

                        <TableData>
                          <strong>Comercial: </strong>
                          {contribuinteData.telefoneComercial || "N/A"}
                        </TableData>

                        <TableData>
                          <strong>Recado: </strong>
                          {contribuinteData.telefoneRecado || "N/A"}
                        </TableData>
                      </TableRow>
                    </tbody>
                    {dependenteData &&
                      (dependenteData.celular ||
                        dependenteData.telefoneResidencial ||
                        dependenteData.telefoneComercial ||
                        dependenteData.telefoneRecado) && (
                        <>
                          <Label style={{ marginTop: 20 }}>
                            Contatos do dependente
                          </Label>
                          <tbody>
                            <TableRow key={`Contato-${contribuinteData.id}`}>
                              <TableData>
                                <strong>Celular: </strong>
                                {dependenteData.celular || "N/A"}
                              </TableData>

                              <TableData>
                                <strong>Residencial: </strong>
                                {dependenteData.telefoneResidencial || "N/A"}
                              </TableData>

                              <TableData>
                                <strong>Comercial: </strong>
                                {dependenteData.telefoneComercial || "N/A"}
                              </TableData>

                              <TableData>
                                <strong>Recado: </strong>
                                {dependenteData.telefoneRecado || "N/A"}
                              </TableData>
                            </TableRow>
                          </tbody>
                        </>
                      )}
                  </Table>
                </TableContainer>
                <StyledHR />
                <BlueTitle marginBottom={1}>
                  Dados de fichas financeiras
                </BlueTitle>

                <ContainerButtons>
                  <Form
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Form.Check
                      type="checkbox"
                      style={{
                        transform: "scale(0.85)",
                        fontSize: "14px",
                      }}
                      id={`checkBoxCompleta`}
                      checked={checkBoxCompleta}
                      onChange={(e) => {
                        handleCheckBox(setCheckBoxCompleta, e.target.checked);
                      }}
                    />
                  </Form>
                  <span>Completa</span>
                  <Form
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Form.Check
                      type="checkbox"
                      style={{
                        transform: "scale(0.85)",
                        fontSize: "14px",
                      }}
                      id={`checkBoxPagas`}
                      checked={checkBoxPagas}
                      onChange={(e) => {
                        handleCheckBox(setCheckBoxPagas, e.target.checked);
                      }}
                    />
                  </Form>
                  <span>Pagas</span>
                </ContainerButtons>
                <ContainerButtons>
                  {editOnly &&
                    selectedFichas.length > 0 &&
                    selectedFichas.some(
                      (installment) =>
                        installment.statusParcela === StatusParcelaEnum.ATIVA
                    ) && (
                      <>
                        <Button
                          type="button"
                          schemaButton="out-primary"
                          action={() => {
                            if (selectedFichas.length <= 0) {
                              Swal.fire({
                                title: "Atenção",
                                text: "Selecione ao menos uma parcela.",
                                icon: "warning",
                                confirmButtonText: "OK",
                                allowOutsideClick: false,
                              });
                            } else {
                              setShowManualClearanceModal(true);
                            }
                          }}
                        >
                          Dar baixa
                        </Button>
                        {/* <Button
                          type="button"
                          schemaButton="out-primary"
                          action={() => {
                            if (selectedFichas.length <= 0) {
                              Swal.fire({
                                title: "Atenção",
                                text: "Selecione ao menos uma parcela.",
                                icon: "warning",
                                confirmButtonText: "OK",
                                allowOutsideClick: false,
                              });
                            } else {
                              setShowCancelInstallmentsModal(true);
                            }
                          }}
                        >
                          Cancelar
                        </Button> */}
                      </>
                    )}
                  {selectedFichas.length > 0 &&
                    selectedFichas.some(
                      (installment) =>
                        installment.statusParcela ===
                        StatusParcelaEnum.CANCELADA
                    ) && (
                      <Button
                        type="button"
                        schemaButton="out-primary"
                        action={() => {
                          if (selectedFichas.length <= 0) {
                            Swal.fire({
                              title: "Atenção",
                              text: "Selecione ao menos uma parcela.",
                              icon: "warning",
                              confirmButtonText: "OK",
                              allowOutsideClick: false,
                            });
                          } else {
                            handleManualClearance();
                          }
                        }}
                      >
                        Reativar
                      </Button>
                    )}
                  {selectedFichas.length > 0 &&
                    selectedFichas.every(
                      (installment) =>
                        installment.statusParcela !==
                          StatusParcelaEnum.CANCELADA &&
                        installment.statusImpressao !==
                          StatusImpressaoEnum.NAO_IMPRIMIR &&
                        installment.statusImpressao !==
                          StatusImpressaoEnum.PENDENTE
                    ) && (
                      <Button
                        type="button"
                        schemaButton="out-primary"
                        action={() => {
                          if (selectedFichas.length <= 0) {
                            Swal.fire({
                              title: "Atenção",
                              text: "Selecione ao menos uma parcela.",
                              icon: "warning",
                              confirmButtonText: "OK",
                              allowOutsideClick: false,
                            });
                          } else {
                            createBillOfPay(selectedFichas);
                          }
                        }}
                      >
                        Imprimir
                      </Button>
                    )}
                  {todasParcelasPagas && (
                    <Button
                      schemaButton="out-primary"
                      action={async () => {
                        if (selectedFichas.length === 0) {
                          Swal.fire(
                            "Atenção",
                            "Selecione ao menos uma parcela para gerar o recibo.",
                            "warning"
                          );
                          return;
                        }
                        try {
                          await gerarReciboParcelaPDF(selectedFichas);
                        } catch (error) {
                          Swal.fire("Erro", "Erro ao gerar o recibo.", "error");
                        }
                      }}
                    >
                      Gerar Recibo
                    </Button>
                  )}

                  {selectedFichas.length === 1 &&
                    selectedFichas.every(
                      (installment) =>
                        installment.idCaixa !== null &&
                        installment.idCaixa !== undefined &&
                        installment.statusParcela === StatusParcelaEnum.PAGA
                    ) && (
                      <Button
                        type="button"
                        schemaButton="out-primary"
                        action={() => {
                          if (selectedFichas.length !== 1) {
                            Swal.fire({
                              title: "Atenção",
                              text: "Selecione uma parcela.",
                              icon: "warning",
                              confirmButtonText: "OK",
                              allowOutsideClick: false,
                            });
                          } else {
                            ReversalManualClearance(selectedFichas[0]);
                            setIsOpen(null);
                          }
                        }}
                      >
                        Estorno baixa
                      </Button>
                    )}

                  {/* {editOnly && (
                    <Button
                      schemaButton="full-primary"
                      action={() => setShowCadastroParcela(true)}
                      icon={
                        <IoIosAddCircleOutline
                          size={20}
                          style={{ marginRight: "8px" }}
                        />
                      }
                      disabled={isRequest}
                    >
                      Cadastrar parcela
                    </Button>
                  )} */}
                </ContainerButtons>
                <TableContainer style={{ minHeight: 450 }}>
                  {isRequestFichaFinanceira ? (
                    <LoadingContainer>
                      <LoadingGif src={loadSCGif} alt="Carregando..." />
                    </LoadingContainer>
                  ) : (
                    <Table id="ficha-financeira-table">
                      <TableHead>
                        <TableRow>
                          <TableHeader>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                minWidth: 10,
                              }}
                            >
                              <Form>
                                <Form.Check
                                  type="checkbox"
                                  style={{
                                    transform: "scale(0.85)",
                                    fontSize: "14px",
                                  }}
                                  id={`default-checkbox-select-all`}
                                  checked={
                                    selectedFichas.length ===
                                      fichaFinanceiraData?.length &&
                                    selectedFichas.length !== 0
                                  }
                                  disabled={isRequest}
                                  onChange={(e) => {
                                    fichaFinanceiraData &&
                                      handleSelectAll(fichaFinanceiraData);
                                  }}
                                />
                              </Form>
                              <span>Todos</span>
                              <OverlayTrigger
                                placement="right"
                                overlay={
                                  <Tooltip id="tooltip-cc">
                                    Selecionar todos os itens da lista
                                  </Tooltip>
                                }
                              >
                                <i
                                  className="fas fa-info-circle"
                                  style={{ cursor: "help" }}
                                ></i>
                              </OverlayTrigger>
                            </div>
                          </TableHeader>
                          <TableHeader>Status</TableHeader>
                          <TableHeader>Nosso número</TableHeader>
                          <TableHeader>Tipo cobrança</TableHeader>
                          <TableHeader>Valor parcela</TableHeader>
                          <TableHeader>Vencimento</TableHeader>
                          <TableHeader>Status impressão</TableHeader>
                          <TableHeader>Status remessa</TableHeader>
                          <TableHeader
                            style={{ width: "1px", whiteSpace: "nowrap" }}
                          >
                            Ações
                          </TableHeader>
                        </TableRow>
                      </TableHead>
                      <tbody>
                        {fichaFinanceiraData &&
                        fichaFinanceiraData.length > 0 ? (
                          fichaFinanceiraData.map((ficha) => (
                            <TableRow key={ficha.id}>
                              <TableData style={{ textAlign: "center" }}>
                                <Form
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Form.Check
                                    type="checkbox"
                                    style={{
                                      transform: "scale(0.85)",
                                      fontSize: "14px",
                                    }}
                                    id={`default-checkbox-${ficha.id}`}
                                    checked={selectedFichas.some(
                                      (installment) =>
                                        installment.id === ficha.id
                                    )}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        if (selectedFichas.length > 0) {
                                          const currentStatus =
                                            selectedFichas[0].statusParcela;
                                          if (
                                            ficha.statusParcela !==
                                            currentStatus
                                          ) {
                                            Swal.fire({
                                              title: "Atenção",
                                              text: `Você só pode selecionar parcelas com status "${currentStatus}" no momento. Desmarque as outras parcelas primeiro.`,
                                              icon: "warning",
                                              confirmButtonText: "OK",
                                              allowOutsideClick: false,
                                            });
                                            e.preventDefault();
                                            return;
                                          }
                                        }
                                        setSelectedFichas([
                                          ...selectedFichas,
                                          ficha,
                                        ]);
                                      } else {
                                        setSelectedFichas((prev) =>
                                          prev.filter(
                                            (item) => item.id !== ficha.id
                                          )
                                        );
                                      }
                                    }}
                                  />
                                </Form>
                              </TableData>
                              <TableData style={{ textAlign: "center" }}>
                                <Badge
                                  style={{
                                    width: "auto",
                                    textAlign: "center",
                                    display: "inline-block",
                                    padding: "10px 15px",
                                    color: "rgba(0, 0, 0, 0.5)",
                                    fontSize: "1rem",
                                    backgroundColor: getBadgeBackground(
                                      ficha.statusParcela as StatusParcelaEnum,
                                      ficha.dataVencimento
                                    ),
                                    border: "none",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                  }}
                                  bg={getBadgeBackground(
                                    ficha.statusParcela as StatusParcelaEnum,
                                    ficha.dataVencimento
                                  )}
                                >
                                  {ficha.statusParcela}
                                </Badge>
                              </TableData>
                              <TableData>{ficha.nossoNumero}</TableData>
                              <TableData>{ficha.tipoCobranca}</TableData>
                              <TableData>
                                {formatCurrency(ficha.valorParcela.toString())}
                              </TableData>
                              <TableData>
                                {formatarData(ficha.dataVencimento as string)}
                              </TableData>
                              <TableData>{ficha.statusImpressao}</TableData>
                              <TableData>{ficha.statusRemessa}</TableData>

                              <TableData
                                key={`actions-${ficha.id}`}
                                style={{
                                  position: "relative",
                                  overflow: "visible",
                                }}
                              >
                                <ButtonAction
                                  onClick={() => toggleDropdown(ficha.id!)}
                                >
                                  {isOpen === ficha.id ? (
                                    <IoMdClose
                                      cursor={"pointer"}
                                      size={20}
                                      style={{ color: Colors.primary }}
                                    />
                                  ) : (
                                    <SlOptionsVertical
                                      cursor={"pointer"}
                                      size={20}
                                      style={{ color: Colors.primary }}
                                    />
                                  )}
                                </ButtonAction>
                                <MenuTable
                                  show={isOpen === ficha.id}
                                  align="start"
                                  isLastRows={
                                    fichaFinanceiraData.length > 0 &&
                                    fichaFinanceiraData.indexOf(ficha) >
                                      fichaFinanceiraData.length -
                                        Math.ceil(
                                          fichaFinanceiraData.length / 2
                                        )
                                  }
                                  ref={(el: HTMLDivElement | null) => {
                                    // Armazena a referência no mapa usando o ID do registro como chave
                                    menuRefsMap.current.set(ficha.id!, el);
                                  }}
                                >
                                  {editOnly &&
                                    ficha.statusParcela ===
                                      StatusParcelaEnum.ATIVA && (
                                      <>
                                        <MenuTableItem
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedFichas([ficha]);
                                            setShowManualClearanceModal(true);
                                            setIsOpen(null);
                                          }}
                                        >
                                          Dar baixa
                                        </MenuTableItem>
                                        <MenuTableDivider />
                                        {/* <MenuTableItem
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedFichas([ficha]);
                                            setShowCancelInstallmentsModal(
                                              true
                                            );
                                            setIsOpen(null);
                                          }}
                                        >
                                          Cancelar
                                        </MenuTableItem>
                                        <MenuTableDivider /> */}
                                      </>
                                    )}

                                  {ficha.statusParcela ===
                                    StatusParcelaEnum.PAGA && (
                                    <>
                                      <MenuTableItem
                                        onClick={(e) => {
                                          e.stopPropagation(); // Evita propagação do evento
                                          gerarReciboParcelaPDF([ficha]);
                                          setSelectedFichas([ficha]);
                                        }}
                                      >
                                        Gerar recibo
                                      </MenuTableItem>
                                      <MenuTableDivider />
                                    </>
                                  )}

                                  {/* {editOnly &&
                                    ficha.statusParcela ===
                                      StatusParcelaEnum.CANCELADA && (
                                      <>
                                        <MenuTableItem
                                          onClick={async (e) => {
                                            e.stopPropagation(); // Evita propagação do evento
                                            setSelectedFichas([ficha]);
                                            setSelectedFicha(ficha);
                                            setIsOpen(null);
                                          }}
                                        >
                                          Reativar
                                        </MenuTableItem>
                                        <MenuTableDivider />
                                      </>
                                    )} */}

                                  {ficha.statusParcela !==
                                    StatusParcelaEnum.CANCELADA &&
                                    ficha.statusImpressao !==
                                      StatusImpressaoEnum.NAO_IMPRIMIR &&
                                    ficha.statusImpressao !==
                                      StatusImpressaoEnum.PENDENTE && (
                                      <>
                                        <MenuTableItem
                                          onClick={(e) => {
                                            e.stopPropagation(); // Evita propagação do evento
                                            createBillOfPay([ficha]);
                                            setIsOpen(null);
                                          }}
                                        >
                                          Imprimir
                                        </MenuTableItem>
                                        <MenuTableDivider />
                                      </>
                                    )}

                                  {ficha.statusParcela !==
                                    StatusParcelaEnum.CANCELADA &&
                                    ficha.qrCodePix &&
                                    ficha.qrCodePix !== "" && (
                                      <>
                                        <MenuTableItem
                                          onClick={(e) => {
                                            e.stopPropagation(); // Evita propagação do evento
                                            setSelectedFichas([ficha]);
                                            setSelectedFicha(ficha);
                                            setShowModalQRCode(true);
                                            setIsOpen(null);
                                          }}
                                        >
                                          Detalhes do PIX
                                        </MenuTableItem>
                                        <MenuTableDivider />
                                      </>
                                    )}

                                  {/* {editOnly &&
                                    (ficha.statusParcela ===
                                      StatusParcelaEnum.ATIVA) && (
                                      <>
                                        <MenuTableItem
                                          onClick={(e) => {
                                            e.stopPropagation(); // Evita propagação do evento
                                            handleUpdate(
                                              ficha.id,
                                              ficha.statusImpressao
                                            );
                                            setIsOpen(null);
                                          }}
                                        >
                                          Trocar status impressão
                                        </MenuTableItem>
                                        <MenuTableDivider />
                                        <MenuTableItem
                                          onClick={(e) => {
                                            e.stopPropagation(); // Evita propagação do evento
                                            handleUpdateRemessa(
                                              ficha.id,
                                              ficha.statusRemessa
                                            );
                                            setIsOpen(null);
                                          }}
                                        >
                                          Trocar status remessa
                                        </MenuTableItem>
                                        <MenuTableDivider />
                                      </>
                                    )} */}

                                  <MenuTableItem
                                    onClick={(e) => {
                                      e.stopPropagation(); // Evita propagação do evento
                                      setSelectedFichas([ficha]);
                                      setSelectedFicha(ficha);
                                      setShowDetailsModal(true);
                                      setIsOpen(null);
                                    }}
                                  >
                                    Ver detalhes
                                  </MenuTableItem>
                                  {ficha.statusParcela ===
                                    StatusParcelaEnum.PAGA &&
                                    ficha.idCaixa && (
                                      <>
                                        <MenuTableDivider />
                                        <MenuTableItem
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedFichas([ficha]);
                                            ReversalManualClearance(ficha);
                                            setIsOpen(null);
                                          }}
                                        >
                                          Estorno baixa
                                        </MenuTableItem>
                                      </>
                                    )}
                                </MenuTable>
                              </TableData>
                            </TableRow>
                          ))
                        ) : (
                          <tr>
                            <TableData colSpan={9} className="text-center">
                              Nenhuma ficha financeira encontrada.
                            </TableData>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  )}
                </TableContainer>
                {fichaFinanceiraData &&
                  fichaFinanceiraData.length > 0 &&
                  totalPages >= 2 && (
                    <Pagination
                      currentPage={currentPage}
                      totalPages={Math.ceil(totalParcelas / itemsPerPage)}
                      onPageChange={handlePageChange}
                    />
                  )}
              </>
            ) : (
              <EmptySearchContainer>
                <EmptySearchMessage>
                  Por favor, utilize um dos campos de busca acima para consulta
                  rápida
                </EmptySearchMessage>
              </EmptySearchContainer>
            )}

            {/* {showCadastroParcela && (
              <CadastroParcela
                onSubmit={() => {
                  setShowCadastroParcela(false);
                }}
                onClose={() => setShowCadastroParcela(false)}
                idContribuinte={contribuinteData?.id!}
                dadosFinanceiros={adjustSetDadosFinanceiros(
                  contribuinteData?.dadosFinanceiros[0]!
                )}
                onParcelaCadastrada={() => null}
              />
            )} */}

            {selectedFicha && (
              <>
                <DetailsModal
                  show={showDetailsModal}
                  onClose={() => setShowDetailsModal(false)}
                  record={selectedFicha}
                  setShowQrCodeModal={setShowModalQRCode}
                />
                <QrCodeModal
                  show={showModalQRCode}
                  onClose={() => setShowModalQRCode(false)}
                  qrCode={selectedFicha?.qrCodePix}
                />
              </>
            )}

            {selectedFichas.length > 0 && (
              <>
                <ManualClearanceModal
                  show={showManualClearanceModal && editOnly}
                  onClose={() => {
                    setShowManualClearanceModal(false);
                    setSelectedFichas([]);
                  }}
                  installments={selectedFichas}
                  onSuccess={async () =>
                    await getFichasFinanceiras(
                      contribuinteData?.id!,
                      currentPage,
                      itemsPerPage,
                      checkBoxCompleta,
                      checkBoxPagas
                    )
                  }
                />
                {/* <CancelInstallmentsModal
                  show={showCancelInstallmentsModal && editOnly}
                  onClose={() => {
                    setShowCancelInstallmentsModal(false);
                  }}
                  installments={selectedFichas}
                  fetchAllParcelas={() =>
                    getFichasFinanceiras(
                      contribuinteData?.id!,
                      currentPage,
                      itemsPerPage,
                      checkBoxCompleta,
                      checkBoxPagas
                    )
                  }
                /> */}
              </>
            )}

            {showSelectDataModal && (
              <ModalSelectData
                show={showSelectDataModal}
                onClose={() => setShowSelectDataModal(false)}
                contribuinteData={contribuinteDataSelect}
                dependenteData={dependenteDataSelect}
                setContribuinteData={setContribuinteData}
                setDependenteData={setDependenteData}
              />
            )}
          </>
        )}
      </MainContainer>
    </div>
  );
};

export default ConsultaRapida;
